// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__d7ero","errorLogs":"EditorFooter_errorLogs__B0VTx"};